module.exports = __webpack_public_path__ + "static/media/freespace.ee2eba5d.svg";